<template>
  <section class="p-1">
    <!-- <bread-crumb :bread-crumbs="['Compliance', 'List of Customers']" /> -->

    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">User Search</div>
        <div>
          <bread-crumb :bread-crumbs="['User Search']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form ref="Searchform" v-model="valid">
            <v-row row-gutters class="px-2">
              <v-col cols="12" lg="2" sm="6" xs="12">
                <v-autocomplete
                  placeholder="Partner"
                  :items="senderPartners"
                  v-model="searchInputs.partner"
                  @input="getAllBranches(searchInputs.partner)"
                  outlined
                  dense
                  :rules="FieldRequired('Partner')"
                  :clearable="isFieldClearable('customer_type')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="2" sm="6" xs="12">
                <v-autocomplete
                  v-model="selectedBranch"
                  :items="BranchData"
                  outlined
                  dense
                  placeholder="Payout Branch"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="2" sm="6" xs="12">
                <v-text-field
                  v-model="searchInputs.login_id"
                  outlined
                  dense
                  placeholder="Login ID"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="2" sm="6" xs="12">
                <v-text-field
                  v-model="searchInputs.email"
                  outlined
                  dense
                  placeholder="User Email"
                ></v-text-field>
              </v-col>

              <div class="d-flex mt-1">
                <div>
                  <v-btn
                    depressed
                    small
                    class="mx-2 ms-3 primary text-capitalize"
                    @click="getUserList()"
                    >Get Results</v-btn
                  >
                </div>
                <div>
                  <v-btn
                    depressed
                    small
                    class="mx-2 text-capitalize"
                    outlined
                    color="primary"
                    @click="clear"
                    >Clear</v-btn
                  >
                </div>
              </div>
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>
      <v-card-text>
        <loading
          :active="loader"
          :is-full-page="false"
          :opacity="0.7"
          color="#ff6b00"
        />
        <v-row row-gutters class="mt-3">
          <v-spacer></v-spacer>
          <v-col cols="12" lg="4" xs="12">
            <v-btn depressed @click="downloadExcelsheet" color="primary" small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
          </v-col>
          <v-col cols="12" lg="4" xs="12"></v-col>
          <v-col cols="12" lg="4" xs="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :items="userList"
        :items-per-page="perPageSize"
        :search="search"
        loading-text="Please select the criteria to view records."
        no-data-text="Please select the criteria to view records."
        item-key="user_id"
        dense
      >
        <template v-slot:item.change_password="{ item }">
          <a class="text-center" @click="sendPasswordLink(item)">
            {{ item.change_password }}
          </a>
        </template>
        <template v-slot:item.two_factor_enabled="{ item }">
          <v-switch
            v-model="item.two_factor_enabled"
            height="0px"
            @click="updateTwoFactStatus(item)"
          >
          </v-switch>
        </template>
        <template v-slot:item.unlock_user="{ item }">
          <v-btn
            v-if="item.unlock_user"
            fab
            x-small
            rounded
            @click="openLockedDialog(item)"
          >
            <v-icon color="primary" small> mdi-lock </v-icon>
          </v-btn>
          <v-btn v-else x-small rounded fab @click="openLockedDialog(item)">
            <v-icon color="success" small> mdi-lock-open-variant </v-icon>
          </v-btn>
        </template>
        <template v-slot:item.is_active="{ item }">
          <v-btn
            depressed
            rounded
            :color="getColor(item.is_active)"
            block
            class="no-uppercase"
            dense
            x-small
            v-if="item.is_active"
            dark
            @click="openStatus(item)"
          >
            Active</v-btn
          >
          <v-btn
            depressed
            rounded
            :color="getColor(item.is_active)"
            block
            class="no-uppercase"
            dense
            v-else
            x-small
            dark
            @click="openStatus(item)"
          >
            Block</v-btn
          >
        </template>
      </v-data-table>
    </v-card>
    <div class="text-center">
      <!-- status dialog -->
      <v-dialog persistent v-model="Statusdialog" width="500">
        <v-card>
          <v-card-title class="grey lighten-2 subtitle-1">
            User Status
          </v-card-title>
          <v-card-text class="mt-2">
            <v-form v-model="valid" ref="UserListtatus">
              <v-row no-gutters class="d-block">
                <v-col md="8">
                  <v-subheader class="required font-weight-bold pl-0 caption"
                    >User Status
                  </v-subheader>
                </v-col>
                <v-col cols="12" md="12">
                  <v-select
                    v-model="userStatus.status"
                    :items="statusList"
                    :rules="statusRules"
                    placeholder="Select User Status"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="d-block">
                <v-col md="8">
                  <v-subheader class="required font-weight-bold pl-0 caption"
                    >Remarks
                  </v-subheader>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="userStatus.remarks"
                    :rules="remarksRules"
                    placeholder="Enter Remarks"
                    dense
                    outlined
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn depressed color="red" text @click="closeStatus()">
              Cancel
            </v-btn>
            <v-btn
              depressed
              rounded
              color="primary"
              text
              @click="userStatusadmin()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- locked  status dialog  -->
      <v-dialog persistent v-model="lockedDialog" width="500">
        <v-card>
          <v-card-title class="border border-bottom">{{ title }}</v-card-title>
          <v-card-text class="h5 py-3"
            >Are you sure you want to {{ title }}?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="updateLockedCustomers"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="closeStatusLockedDialog"
              ><v-icon>mdi-close</v-icon></v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import Loading from "vue-loading-overlay";
import alerts from "@/mixins/alerts";
import partnerService from "@/services/partnerService/partnerService.js";
import userService from "@/services/UserService/userService.js";
import { FieldRequired } from "@/utils/validation.js";
export default {
  name: "User Search",
  mixins: [alerts],
  data: () => {
    return {
      FieldRequired,
      title: "",
      selectedBranch: null,
      lockedDialog: false,
      searchInputs: {
        partner: null,
        payout_branch: null,
        login_id: null,
        email: null,
      },
      userStatus: {
        id: "",
        status: "",
        remarks: "",
      },
      lockedStatus: {
        user_id: "",
        lock_status: null,
        remarks: "",
        data: null,
      },
      statusList: [
        { text: "Active", value: "true" },
        { text: "In-Active", value: "false" },
      ],
      statusRules: [(v) => !!v || "User Status is required"],
      remarksRules: [(v) => !!v || "Remarks is required"],
      valid: true,
      loader: false,
      Statusdialog: false,
      userList: [],
      senderPartners: [],
      BranchData: [],
      search: "",
      perPageSize: window.innerWidth < 1600 ? 10 : 15,
      headers: [
        { text: "ID", value: "id" },
        { text: "Login Id", value: "login_id" },
        { text: "Name", value: "full_name" },
        { text: "Email", value: "email" },
        // { text: "Agent", value: "agent_type_data.value" },
        // { text: "Branch", value: "agent_or_branch" },
        { text: "Last Login", value: "last_login" },
        { text: "Unlock User", value: "unlock_user" },
        { text: "Status", value: "is_active", width: 100 },
        { text: "Change Password", value: "change_password" },
        { text: "2FA Status", value: "two_factor_enabled" },
      ],
    };
  },
  components: {
    BreadCrumb,
    Loading,
  },
  mounted() {
    this.getAllSendPartners();
  },
  computed: {},

  methods: {
    getColor(is_active) {
      if (is_active) return "green";
      else return "orange";
    },

    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "List of Users");
      }
    },
    async getUserList() {
      const validate = this.$refs.Searchform.validate();
      if (validate) {
        this.loader = true;
        this.searchInputs.payout_branch = this.selectedBranch;
        const params = {
          partner_id: this.searchInputs.partner,
          payout_branch: this.searchInputs.payout_branch
            ? this.searchInputs.payout_branch
            : null,
          login_id: this.searchInputs.login_id
            ? this.searchInputs.login_id
            : null,
          email: this.searchInputs.email ? this.searchInputs.email : null,
        };
        try {
          const responseData = await partnerService.getUserSearchData(params);
          if (responseData.data.status_code === 200) {
            this.userList = responseData.data.data;
            this.stoploader();
          } else {
            this.loader = false;
            this.userList = [];
          }
          console.log("UserList", responseData);
        } catch (e) {
          console.error(e);
          this.loader = false;
          this.userList = [];
        }
      }
    },
    async getAllBranches(id) {
      this.selectedBranch = null;
      this.searchInputs.login_id = null;
      this.searchInputs.email = null;

      try {
        const responseData = await partnerService.getAllBranches(id);
        if (responseData.data.status_code === 200) {
          this.BranchData = responseData.data.data.map((i) => {
            return { text: i.partner_name, value: i.partner_id };
          });
        }
        console.log("payments", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async getAllSendPartners() {
      try {
        const responseData = await partnerService.getActivePartners();
        if (responseData.data.status_code === 200) {
          this.senderPartners = responseData.data.data.map((i) => {
            return { text: i.partner_name, value: i.partner_id };
          });
        }

        console.log("payments", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    isFieldClearable(fieldName) {
      return (
        this.searchInputs[fieldName] !== "" &&
        this.searchInputs[fieldName] !== null
      );
    },
    clear() {
      for (const fieldName in this.searchInputs) {
        this.searchInputs[fieldName] = "";
      }
    },

    openLockedDialog(item) {
      this.title = item.unlock_user ? "Unlock" : "Lock";
      this.lockedDialog = true;
      this.lockedStatus.user_id = item.user_id;
      this.lockedStatus.lock_status = item.unlock_user ? false : true;
      this.lockedStatus.remarks = "";
      this.lockedStatus.data = item;
    },
    closeStatusLockedDialog() {
      this.lockedDialog = false;
    },

    async updateLockedCustomers() {
      this.loader = true;
      try {
        const responseData = await userService.updateLockedCustms(
          this.lockedStatus.user_id,
          this.lockedStatus.lock_status,
          this.lockedStatus.remarks,
          this.lockedStatus.data,
        );
        if (responseData.data.status_code == 200) {
          console.log("response", responseData);
          this.showAlertSuccess("User status updated successfully");
          this.lockedDialog = false;
          this.getUserList();
          this.stoploader();
        } else {
          this.showAlertError("Failed: " + responseData.data.message);
          this.loader = false;
        }
      } catch (error) {
        this.showAlertError("Failed: Something went wrong");
        console.log(error.response);
        this.loader = false;
      }
    },
    async sendPasswordLink(item) {
      this.loader = true;
      try {
        const responseData = await partnerService.getPasswordLink(
          item.login_id,
        );
        if (responseData.data.status_code == 200) {
          console.log("response", responseData);
          this.showAlertSuccess(responseData.data.message);
          this.getUserList();
          this.stoploader();
        } else {
          this.showAlertError("Failed: " + responseData.data.message);
          this.loader = false;
        }
      } catch (error) {
        this.showAlertError("Failed: Something went wrong");
        console.log(error.response);
        this.loader = false;
      }
    },

    openStatus(data) {
      console.log(data);
      this.Statusdialog = true;
      this.userStatus.id = data.id;
      this.userStatus.status = data.is_active ? "true" : "false";
      this.userStatus.remarks = data.remarks;
      console.log(this.userStatus);
    },

    closeStatus() {
      this.Statusdialog = false;
    },

    async userStatusadmin() {
      const validate = this.$refs.UserListtatus.validate();
      if (validate === true) {
        this.loader = true;
        try {
          const responseData = await partnerService.updateUserSearchStatus(
            this.userStatus.id,
            this.userStatus.status,
          );
          if (responseData && responseData.data.status_code === 200) {
            this.stoploader();
            this.showAlertSuccess(responseData.data.message);
            this.getUserList();
            this.$refs.UserListtatus.reset();
            this.Statusdialog = false;
          } else {
            this.showAlertError(responseData.data.message);
            this.stoploader();
          }
        } catch (error) {
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
          this.loader = false;
        }
      }
    },
    async updateTwoFactStatus(item) {
      const status = item.two_factor_enabled ? true : false;
      this.loader = true;
      try {
        const responseData = await userService.updateUsertfaStatus(
          item.login_id,
          status,
        );
        if (responseData && responseData.data.status_code === 200) {
          this.stoploader();
          this.showAlertSuccess(responseData.data.message);
          this.getUserList();
        } else {
          this.showAlertError(responseData.data.message);
          this.stoploader();
        }
      } catch (error) {
        console.log(error.response);
        this.showAlertError("Something went wrong please try again later.");
        this.loader = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
  min-width: 64px !important;
  padding: 0 16px !important;
}
.select-width {
  max-width: 60px;
}

.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
